/**
 * Static public URLs — do not import these through Parcel.
 * Parcel’s import-map for image/PDF url deps has been incomplete in production
 * (missing IDs like 41df6), which blanks the whole site.
 * Files live in public/img and are copied to dist/img on build.
 */
const ASSET_V = "20260816c";

/** Silent, faststart H.264 — required for reliable iOS muted autoplay */
export const heroVideoSrc = `/img/mizu-hero.mp4?v=${ASSET_V}`;
export const heroPoster = `/img/mizu-hero-poster.jpg?v=${ASSET_V}`;

export const icons = {
  logo: `/img/mizulogo.png?v=${ASSET_V}`,
  logoWhite: `/img/mizuwhite.png?v=${ASSET_V}`,
  landingBg: `/img/landingpagebg.png?v=${ASSET_V}`,
  heroPoster,
  coffee: `/img/mizu-coffee.png?v=${ASSET_V}`,
  cup: `/img/cup.png?v=${ASSET_V}`,
  location: `/img/location.png?v=${ASSET_V}`,
  clock: `/img/clock.png?v=${ASSET_V}`,
  mail: `/img/mail.png?v=${ASSET_V}`,
  insta: `/img/insta.png?v=${ASSET_V}`,
};
